module.exports = __webpack_public_path__ + "img/3-3.994e1c70.svg";